import { createAction, props } from '@ngrx/store';
import { ArticleModel } from '../model/article.model';

export const ARTICLE = '[Blog Article] Article';
export const ARTICLE_SUCCESS = '[Blog Article] Article Success';
export const ARTICLE_FAILURE = '[Blog Article] Article Failure';

export const article = createAction(
    ARTICLE,
    props<{slug: string}>()
)

export const articleSuccess = createAction(
    ARTICLE_SUCCESS,
    props<{article: ArticleModel}>()
)

export const articleFailure = createAction(
    ARTICLE_FAILURE,
    props<{error: string}>()
)
